<template>
    <div>
        <div class="row">
            <div class="form-group col-lg-4">
                <label
                    class="col-form-label font-weight-bold"
                    :for="'participantsMaxNum' + _uid"
                >
                    {{ $t("registers.events.generalData.participantsMaxNum") }}
                </label>
                <input
                    type="number"
                    min="0"
                    class="form-control"
                    :disabled="details"
                    v-model="participantsMaxNum"
                    @input="participantsMaxNumInputChanged"
                    :name="'participantsMaxNum' + _uid"
                    :id="'participantsMaxNum' + _uid"
                />
            </div>

            <div class="form-group col-lg-4">
                <label
                    for="eventStatus"
                    class="col-form-label font-weight-bold"
                    >{{ $t("registerStatus.title") }}</label
                >
                <dynamic-dropdown
                    id="eventStatus"
                    :apiUrl="eventStatusDropdownApiUrl"
                    :required="false"
                    :disabled="details"
                    :fieldName="''"
                    :value="model.statusId"
                    @input="eventStatusSelectorChanged"
                >
                </dynamic-dropdown>
            </div>

            <div class="form-group col-lg-4 pt-3">
                <div class="d-flex justify-content-between">
                    <vs-checkbox
                        v-model="model.isPublic"
                        @input="isPublicInputChanged"
                        :disabled="details"
                        :name="'isPublic' + _uid"
                        :id="'isPublic' + _uid"
                        >{{ $t("registers.events.generalData.public") }}
                    </vs-checkbox>
                    <vs-checkbox
                        v-model="model.excludeFromReporting"
                        :readonly="details"
                        :disabled="details"
                        @input="excludeFromReportingInputChanged"
                        :name="'excludeFromReporting' + _uid"
                        :id="'excludeFromReporting' + _uid"
                        >{{
                            $t(
                                "registers.events.generalData.excludeFromReporting"
                            )
                        }}
                    </vs-checkbox>
                    <vs-checkbox
                        v-model="model.isLockedForEdit"
                        :disabled="details"
                        @input="lockedForEditInputChanged"
                        :name="'lockedForEdit' + _uid"
                        :id="'lockedForEdit' + _uid"
                        >{{ $t("registers.events.generalData.lockedForEdit") }}
                    </vs-checkbox>
                </div>
            </div>

            <div class="form-group col-lg-4">
                <label
                    :for="'eventType' + _uid"
                    class="col-form-label font-weight-bold"
                    >{{ $t("registers.events.gridHeaders.eventType") }}</label
                >
                <nomenclature-dropdown
                    :load-by-parent-sort="true"
                    :parent-sort="nomenclature.EventType"
                    v-model="model.eventTypeId"
                    :disabled="details"
                    :fieldName="$t('registers.events.gridHeaders.eventType')"
                    :id="'eventType' + _uid"
                    :name="'eventType' + _uid"
                    @textChange="textChanged"
                ></nomenclature-dropdown>
            </div>
            <div class="form-group col-lg-4" v-show="model.isModuleEvent">
                <label
                    :for="'moduleName' + _uid"
                    class="col-form-label font-weight-bold"
                    >{{ $t("registers.events.gridHeaders.moduleName") }}</label
                >
                <kendo-autocomplete
                    :data-source-ref="'eventModuleDatasource'"
                    :data-text-field="'text'"
                    v-model="model.moduleName"
                    :filter="filterOperator"
                    :disabled="details"
                    :placeholder="$t('choose')"
                    :clear-button="true"
                    :name="'moduleName' + _uid"
                    :id="'moduleName' + _uid"
                    :height="500"

                    style="width: 100%"
                >
                    <kendo-datasource
                        ref="eventModuleDatasource"
                        slot="kendo-datasource"
                        :transport="eventModuleTransportSettings"
                        :server-filtering="true"
                        :schema-data="'data'"
                    >
                    </kendo-datasource>
                </kendo-autocomplete>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-lg-4 col-md-6">
                <label class="col-form-label"></label>
                <vs-checkbox
                    class="justify-content-start"
                    v-model="model.useExtSubscriptionService"
                    :disabled="details"
                    @input="useExtSubscriptionServiceInputChanged"
                    :name="'useExtSubscriptionService' + _uid"
                    :id="'useExtSubscriptionService' + _uid"
                    >{{
                        $t(
                            "registers.events.gridHeaders.useExtSubscriptionService"
                        )
                    }}
                </vs-checkbox>
            </div>
            <div class="form-group col-lg-8 col-md-6">
                <input
                    type="url"
                    class="form-control"
                    v-show="model.useExtSubscriptionService"
                    v-model="extSubscriptionService"
                    @input="extSubscriptionServiceInputChanged"
                    :placeholder="
                        $t(
                            'registers.events.gridHeaders.extSubscriptionService'
                        )
                    "
                    :readonly="details"
                    :name="'extSubscriptionService' + _uid"
                    :id="'extSubscriptionService' + _uid"
                />
            </div>
        </div>

        <div class="accordion mt-3" id="moodleSync">
            <div class="card">
                <div class="card-header bg-light" id="moodleSyncHeading">
                    <div
                        class="btn-toolbar justify-content-between pr-3"
                        role="toolbar"
                        aria-label="Moodle toolbar"
                    >
                        <div>
                            <button
                                class="btn btn-link text-primary"
                                type="button"
                                data-toggle="collapse"
                                data-target="#moodleSyncDetails"
                                aria-expanded="false"
                                aria-controls="moodleSyncDetails"
                            >
                                <i class="fas fa-info-circle"></i>
                                {{
                                    $t(
                                        "registers.events.generalData.moodleSyncResult"
                                    )
                                }}
                            </button>
                        </div>
                        <div class="form-group row">
                            <label
                                class="col-form-label font-weight-bold"
                                for="moodleLink"
                                >{{
                                    $t(
                                        "registers.events.generalData.syncedWithMoodle"
                                    )
                                }}:</label
                            >
                            <div class="m-2">
                                <span
                                    :class="
                                        model.syncedWithMoodle
                                            ? 'badge badge-success'
                                            : 'badge badge-warning'
                                    "
                                    >{{
                                        model.syncedWithMoodle
                                            ? $t("yes")
                                            : $t("no")
                                    }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    id="moodleSyncDetails"
                    class="collapse"
                    aria-labelledby="moodleSyncHeading"
                    data-parent="#moodleSync"
                >
                    <div v-if="!hideMoodleSynDetails" class="card-body">
                        <div class="form-row">
                            <div class="col-md-8 col-sm-12">
                                <div class="form-group row">
                                    <label
                                        for="moodleLink"
                                        class="col-sm-12 col-md-6 font-weight-bold"
                                        >{{
                                            $t(
                                                "registers.events.generalData.eventLink"
                                            )
                                        }}:</label
                                    >
                                    <div class="col-sm-12 col-md-6">
                                        <a
                                            target="_blank"
                                            :href="model.moodleEventLink"
                                            >{{ model.moodleEventLink }}</a
                                        >
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label
                                        for="moodleLink"
                                        class="col-sm-12 col-md-6 font-weight-bold"
                                        >{{
                                            $t(
                                                "registers.events.generalData.syncedWithMoodle"
                                            )
                                        }}:</label
                                    >
                                    <div class="col-sm-12 col-md-6">
                                        <span
                                            :class="
                                                model.syncedWithMoodle
                                                    ? 'badge badge-success'
                                                    : 'badge badge-warning'
                                            "
                                            >{{
                                                model.syncedWithMoodle
                                                    ? $t("yes")
                                                    : $t("no")
                                            }}</span
                                        >
                                    </div>
                                </div>

                                <div
                                    v-if="
                                        allowSyncWithMoodle &&
                                        !isLockedForEdit &&
                                        !details
                                    "
                                >
                                    <button
                                        class="ml-0 btn btn-info"
                                        @click.stop="syncWithMoodle"
                                        :disabled="sync"
                                    >
                                        <i
                                            class="fas fa-spinner fa-spin"
                                            v-if="sync"
                                        ></i>
                                        <i class="fas fa-sync" v-else></i>
                                        {{
                                            $t("buttons.syncWithMoodle.btnText")
                                        }}
                                    </button>
                                </div>
                                <h5
                                    v-if="!allowSyncWithMoodle"
                                    class="text-warning"
                                >
                                    {{
                                        $t(
                                            "registers.events.generalData.syncWithMoodleForPrivateEventBan"
                                        )
                                    }}
                                </h5>
                                <h5 v-if="isLockedForEdit" class="text-warning">
                                    {{ $t("registers.events.lockedForEdit") }}
                                </h5>
                            </div>
                            <div class="col-md-4 col-sm-12">
                                <label
                                    class="font-weight-bold"
                                    :for="'moodleSyncResult' + _uid"
                                    >{{
                                        $t(
                                            "registers.events.generalData.moodleSyncResult"
                                        )
                                    }}</label
                                >
                                <textarea
                                    rows="5"
                                    class="form-control"
                                    v-model="model.moodleSyncResult"
                                    :readonly="true"
                                    :name="'moodleSyncResult' + _uid"
                                    :id="'moodleSyncResult' + _uid"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div v-else class="card-body">
                        <div class="alert alert-warning" role="alert">
                            <h5>
                                {{
                                    $t(
                                        "registers.events.warnings.eventHasChanged"
                                    )
                                }}
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { RegisterEntityExtension } from "../../models/models";
import DynamicDropdown from "../../components/dropdown/DynamicDropdown";
import NomenclatureDropdown from "../../components/dropdown/NomenclatureDropdown";
import { NomenclatureParentBySort } from "../../models/enums";
import { mapGetters } from "vuex";

export default {
    props: {
        model: {
            type: RegisterEntityExtension,
        },
        details: {
            type: Boolean,
            default: false,
        },
        registerId: {
            type: [Number, String],
            required: true,
        },
        entryId: {
            type: [Number, String],
        },
        isEvent: {
            type: Boolean,
            default: false,
        },
        registerName: {
            type: String,
            default: "",
        },
    },
    components: {
        DynamicDropdown,
        NomenclatureDropdown,
    },
    data() {
        return {
            participantsMaxNum: 0,
            excludeFromReporting: false,
            extSubscriptionService: "",
            sync: false,
            eventStatusDropdownApiUrl: "api/events/statusDropdownModels",
            origData: null,
            nomenclature: NomenclatureParentBySort,
            eventModuleTransportSettings: {
                read: {
                    url:
                        this.$store.getters.baseUrl +
                        `/api/events/modulesDropdownSource`,
                    dataType: "json",
                    type: "POST",
                    contentType: "application/json",
                    beforeSend: this.beforeSend,
                },
                parameterMap: this.parameterMap,
            },
            filterOperator: 'contains'
        };
    },
    methods: {
        beforeSend: function (req) {
            if (this.authToken) {
                req.setRequestHeader(
                    "Authorization",
                    "Bearer " + this.authToken
                );
            }
        },
        parameterMap(options, operation) {
            if (operation !== "read" && options.models) {
                return { models: kendo.stringify(options.models) };
            } else {
                return kendo.stringify(options);
            }
        },
        loadInitialValue() {
            this.participantsMaxNum = this.model.participantsMaxNum;
            this.excludeFromReporting = this.model.excludeFromReporting;
            this.extSubscriptionService = this.model.extSubscriptionService;

            this.origData = {
                isPublic: this.model.isPublic,
                excludeFromReporting: this.model.excludeFromReporting,
                isLockedForEdit: this.model.isLockedForEdit,
                useExtSubscriptionService: this.model.useExtSubscriptionService,
                extSubscriptionService: this.model.extSubscriptionService,
            };
        },
        participantsMaxNumInputChanged(event) {
            this.model.participantsMaxNum = event.target.value;
            this.$emit("input", event.target.value);
        },
        extSubscriptionServiceInputChanged(event) {
            this.model.extSubscriptionService = event.target.value;
            this.$emit("input", event.target.value);
        },
        isPublicInputChanged(val) {
            this.model.isPublic = val;
            this.$emit("input", val);
        },
        excludeFromReportingInputChanged(val) {
            this.model.excludeFromReporting = val;
            this.$emit("input", val);
        },
        lockedForEditInputChanged(val) {
            this.model.isLockedForEdit = val;
            this.$emit("input", val);
        },
        useExtSubscriptionServiceInputChanged(val) {
            this.model.useExtSubscriptionService = val;
            this.$emit("input", val);
        },
        eventStatusSelectorChanged(value) {
            let newValue = Number(value);
            if (!isNaN(newValue)) {
                this.model.statusId = newValue;
            }
            this.$emit("input", val);
        },
        syncWithMoodle() {
            this.sync = true;

            this.$http
                .get("/api/moodle/syncEventWithMoodle", {
                    params: {
                        registerEntityId: this.entryId,
                    },
                })
                .then((response) => {
                    this.$vs.notify({
                        title: this.$t("buttons.syncWithMoodle.btnText"),
                        text: this.$helpers.responseMessage(response),
                        color: "success",
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t(
                            "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                        ),
                        text: this.$helpers.errorText(error),
                        color: "danger",
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => {
                    this.sync = false;
                });
        },
        textChanged(text) {
            this.model.isModuleEvent = text
                && (text.toLowerCase().indexOf("модул") !== -1 || text.toLowerCase().indexOf("modul") !== -1);
        }
    },
    mounted() {
        this.loadInitialValue();
    },
    computed: {
        ...mapGetters(["authToken"]),
        allowSyncWithMoodle() {
            return (
                this.model.isPublic === true ||
                this.model.syncPrivateEventsWithMoodle === true
            );
        },
        isLockedForEdit() {
            return this.model.isLockedForEdit === true;
        },
        hideMoodleSynDetails() {
            if (!this.origData || !this.model) {
                return false;
            }

            return (
                this.origData.isPublic !== this.model.isPublic ||
                this.origData.excludeFromReporting !==
                    this.model.excludeFromReporting ||
                this.origData.isLockedForEdit !== this.model.isLockedForEdit ||
                this.origData.useExtSubscriptionService !==
                    this.model.useExtSubscriptionService ||
                this.origData.extSubscriptionService !==
                    this.model.extSubscriptionService
            );
        },
    },
};
</script>
